import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { usersAPI, videosAPI } from '../../services/api';
import Loading from '../../components/common/Loading';

const UserDashboard = () => {
  const [stats, setStats] = useState({
    channels: 0,
    videos: 0,
    pendingVideos: 0,
    doneVideos: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [channelsRes, videosRes, pendingRes, doneRes] = await Promise.all([
          usersAPI.getMyChannels(),
          usersAPI.getMyVideos({ limit: 1 }),
          usersAPI.getMyVideos({ status: 'pending', limit: 1 }),
          usersAPI.getMyVideos({ status: 'done', limit: 1 }),
        ]);

        setStats({
          channels: channelsRes.data.length || 0,
          videos: videosRes.data.count || 0,
          pendingVideos: pendingRes.data.count || 0,
          doneVideos: doneRes.data.count || 0,
        });
      } catch (error) {
        console.error('Error fetching stats:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) return <Loading />;

  const statCards = [
    {
      title: 'Mes Chaînes',
      value: stats.channels,
      icon: '📺',
      color: '#6366f1',
      link: '/dashboard/my-channels',
    },
    {
      title: 'Mes Vidéos',
      value: stats.videos,
      icon: '🎬',
      color: '#8b5cf6',
      link: '/dashboard/my-videos',
    },
    {
      title: 'En attente',
      value: stats.pendingVideos,
      icon: '⏳',
      color: '#f59e0b',
      link: '/dashboard/my-videos?status=pending',
    },
    {
      title: 'Terminées',
      value: stats.doneVideos,
      icon: '✅',
      color: '#10b981',
      link: '/dashboard/my-videos?status=done',
    },
  ];

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Mon Dashboard</h1>
        <p style={styles.subtitle}>Vue d'ensemble de vos activités</p>
      </div>

      <div style={styles.statsGrid}>
        {statCards.map((card, index) => (
          <Link
            key={index}
            to={card.link}
            style={{
              ...styles.statCard,
              '--card-color': card.color,
            }}
          >
            <div style={styles.statIcon}>{card.icon}</div>
            <div style={styles.statContent}>
              <h3 style={styles.statTitle}>{card.title}</h3>
              <p style={styles.statValue}>{card.value}</p>
            </div>
          </Link>
        ))}
      </div>

      <div style={styles.quickActions}>
        <h2 style={styles.sectionTitle}>Accès rapide</h2>
        <div style={styles.actionsGrid}>
          <Link to="/dashboard/my-channels" style={styles.actionCard}>
            <span style={styles.actionIcon}>📺</span>
            <span>Voir mes chaînes</span>
          </Link>
          <Link to="/dashboard/my-videos" style={styles.actionCard}>
            <span style={styles.actionIcon}>🎬</span>
            <span>Voir mes vidéos</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  header: {
    marginBottom: '2rem',
  },
  title: {
    fontSize: '2rem',
    fontWeight: 700,
    color: 'var(--text)',
    marginBottom: '0.5rem',
  },
  subtitle: {
    color: 'var(--text-light)',
    fontSize: '1rem',
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '1.5rem',
    marginBottom: '3rem',
  },
  statCard: {
    background: 'white',
    borderRadius: '1rem',
    padding: '1.5rem',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    textDecoration: 'none',
    color: 'var(--text)',
    transition: 'all 0.2s ease',
    borderLeft: '4px solid var(--card-color)',
  },
  statIcon: {
    fontSize: '2.5rem',
  },
  statContent: {
    flex: 1,
  },
  statTitle: {
    fontSize: '0.875rem',
    color: 'var(--text-light)',
    marginBottom: '0.25rem',
  },
  statValue: {
    fontSize: '2rem',
    fontWeight: 700,
    color: 'var(--text)',
  },
  quickActions: {
    background: 'white',
    borderRadius: '1rem',
    padding: '2rem',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
  sectionTitle: {
    fontSize: '1.5rem',
    fontWeight: 600,
    color: 'var(--text)',
    marginBottom: '1.5rem',
  },
  actionsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '1rem',
  },
  actionCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    padding: '1rem',
    background: 'var(--light)',
    borderRadius: '0.5rem',
    textDecoration: 'none',
    color: 'var(--text)',
    transition: 'all 0.2s ease',
    border: '1px solid var(--border)',
  },
  actionIcon: {
    fontSize: '1.5rem',
  },
};

export default UserDashboard;








